import { Component } from 'react'

import {
  CheckboxInput,
  makeAutobindedInput
} from '../../../../shared/FormBuilder'

const style = {
  headerContainer: {
    overflow: 'hidden',
    marginLeft: '0.5em',
    marginRight: '0.5em'
  },
  header: {
    display: 'flex',
    float: 'left'
  },
  headerSpan: {
    display: 'inline-block',
    fontSize: '1.3em',
    fontWeight: '300',
    color: '#222',
    paddingBottom: '5px',
    paddingLeft: '5px'
  },
  hyperLinkStyle: {
    color: '#1976D2',
    fontSize: '22px'
  },
  linkSpan: {
    fontWeight: '300'
  }
}

class SectionHeader extends Component {
  constructor (props) {
    super(props)

    this.handleAnchorClick = this.handleAnchorClick.bind(this)
  }

  renderCheckbox () {
    const { name } = this.props
    return (
      <div className='nh-ros-check'>
        <CheckboxInput
          label='Reviewed and Negative'
          name={name}
        />
      </div>
    )
  }

  handleAnchorClick (event) {
    let { hash } = event.currentTarget

    if (typeof hash !== 'string') {
      return
    }

    let element = document.querySelector(hash)

    if (!element) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  render () {
    const {
      header: { icon, label, type }
    } = this.props
    return (
      <div
        style={style.headerContainer}
        className='margin-top'
      >
        <div style={style.header}>
          {icon}
          <div>
            <span style={style.headerSpan}>{label}</span>
            {type === 'RoS' ? this.renderCheckbox() : null}
          </div>
        </div>
        <div style={{ float: 'right' }}>
          <a
            href='#top'
            style={style.hyperLinkStyle}
            onClick={this.handleAnchorClick}
          >
            <span style={style.linkSpan}> Top </span>
            <i className='fa fa-caret-up' />
          </a>
        </div>
      </div>
    )
  }
}

export default makeAutobindedInput(SectionHeader)
